<template>
  <div class="block block-fx-shadow block-mode-loading-refresh" :class="{'block-mode-loading': isProcessing}">
    <div class="block-header block-header-default text-center">
      <h3 class="block-title">Общая статистика по статусам должников</h3>
    </div>
    <div class="block-content">
      <doughnut-chart :chart-data="datacollection" :options="chartOptions" :height="250"></doughnut-chart>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '../../../../partials/charts/DoughnutChart.js';

export default {
  components: {
    DoughnutChart,
  },
  props: [
    'userId',
  ],
  data() {
    return {
      isProcessing: false,
      datacollection: null,
      chartOptions: {
        responsive: true,
        maintainAspectRation: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: true,
          },
        },
        cutoutPercentage: 70,
      },
    };
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    fetchStats() {
      this.isProcessing = true;
      window.axios.get('/users/charts/debts')
        .then((res) => {
          this.datacollection = res.data.chartdata;
          this.isProcessing = false;
        });
    },
  },
};
</script>
